export default __webpack_public_path__ + "static/media/parking.df0e42da.svg";